import React, { useState } from "react";
import { View, ScrollView, Text, StyleSheet, Platform } from "react-native";

import integrationStyles from "../integrationStyles";
import IntegrationIcons from "../../../common/icons/integrations/index";
import appStyles from "../../../../appStyles";
import AppTheme from "../../../AppTheme";
import ManaButton from "../../../common/ManaButton";
import IntegrationFabButton from "../../home/IntegrationFabButton";
import { hasItems, isNativeApp } from "../../../../../helpers/utils";
import steps from "../steps";
import CalendarIntegrationSelection from "./CalendarIntegrationSelection";
import IntegrationsHelper from "../../IntegrationsHelper";

const RETRY_INTERVAL = 5000;
const INITIAL_INTERVAL = 100;

export default function CalendarAccount({
  controller,
  account,
  calendarType,
  goToStep = () => {},
  goBack = () => {},
  onContinue,
}) {
  const [isLoading, setIsLoading] = useState(false);
  const [calendars, setCalendars] = useState(null);
  const [fetchInterval, setFetchInterval] = useState(null);

  function clearTimer() {
    if (fetchInterval != null) {
      clearTimeout(fetchInterval);
      setFetchInterval(null);
    }
  }

  // ------------------------------------- METHODS -------------------------------------
  const _fetchCalendars = () => {
    const action = {
      action: "get-calendars",
      account: account.email,
    };

    controller.apiService.cardAction(action).then((reply) => {
      if (reply) {
        clearTimer();

        setCalendars(reply);
        setIsLoading(false);
      } else {
        setTimeout(_fetchCalendars, RETRY_INTERVAL);
      }
    });
  };

  const confirmAccount = (account) => {
    setIsLoading(true);
    if (fetchInterval == null) {
      setFetchInterval(setTimeout(_fetchCalendars, INITIAL_INTERVAL));
    }
  };

  const startOver = (account) => {
    IntegrationsHelper.saveIntegrationSource(
      controller,
      {
        type: "google_calendar",
        disconnect: true,
        account: account.email,
      },
      () => {
        goBack();
      },
    );
  };

  const skipCustomization = () => {
    clearTimer();
    goToStep(isNativeApp() ? steps.checklist : steps.desktop);
  };

  if (hasItems(calendars)) {
    clearTimer();
  }

  return hasItems(calendars) ? (
    <CalendarIntegrationSelection
      controller={controller}
      account={account}
      calendars={calendars}
      calendarType={calendarType}
      goToStep={goToStep}
      onContinue={onContinue}
    />
  ) : (
    <>
      <ScrollView
        style={(appStyles.scrollView, { paddingHorizontal: 16 })}
        contentContainerStyle={appStyles.scrollViewContent}
      >
        <Text style={integrationStyles.header}>Is this the right account?</Text>
        <Text style={styles.email}>{account.email}</Text>

        <View
          style={{
            alignItems: "center",
            marginTop: 104,
            marginBottom: 143,
          }}
        >
          <IntegrationIcons.CalendarBigIcon />
        </View>
      </ScrollView>

      {isLoading ? (
        <IntegrationFabButton
          style={{ bottom: 0 }}
          mariOptions={{
            highlight: true,
            isLoading: isLoading,
            mariMessage: "Just a minute, we’re loading your calendars now!",
            mariAction: [
              {
                text: "Skip customization and connect all calendars",
                style: styles.mariButton,
                buttonTextStyle: styles.mariButtonText,
                onPress: skipCustomization,
              },
            ],
          }}
        />
      ) : (
        <View
          style={[appStyles.footerButtons, appStyles.verticalFooterButtons]}
        >
          <ManaButton
            isMainButton
            text={"Yes, that's it"}
            onPress={() => confirmAccount(account)}
            style={appStyles.bottomButton}
            textStyle={appStyles.bottomButtonText}
          />

          <Text
            style={integrationStyles.skipText}
            onPress={() => startOver(account)}
          >
            No, start over
          </Text>
        </View>
      )}
    </>
  );
}

const styles = StyleSheet.create({
  email: {
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-SemiBold",
    }),
    fontWeight: "600",
    fontSize: 20,
    lineHeight: 30,
    letterSpacing: 1,
    color: AppTheme.DEFAULT_COLOR,
    textAlign: "center",
    marginTop: 67,
  },
  mariButton: {
    maxWidth: "90%",
    backgroundColor: "transparent",
  },
  mariButtonText: {
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-SemiBold",
    }),
    fontWeight: "600",
    fontSize: 12,
    lineHeight: 15,
    letterSpacing: 0.175,
    color: AppTheme.highlightColor,
  },
});
